import { compose, lifecycle, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import nonOptimalStates from '../../../common/hoc/nonOptimalStates';
import Barbers from '../../barbers/Barbers';
import Sale from '../components/Sale';
import { SERVICES_TAB, MEMBERSHIPS_TAB } from '../constants';
import { UNASSIGNED_BARBER } from '../../constants';
import { getNoBarbers } from '../../order/selectors';
import withValidateSale from '../../hoc/withValidateSale';
import { resetOrder, addBarber, setPreserveOrderCustomer } from '../../order/actions';
import { setCustomer } from '../../customer/actions';
import { selectTab, resetTab } from '../actions';
import { getActiveTab } from '../selectors';

export default compose(
    withValidateSale,
    connect(state => ({
      noBarber: getNoBarbers(state),
      tab: getActiveTab(state),
    }), {
      resetOrder,
      setCustomer,
      setPreserveOrderCustomer,
      addBarber,
      selectActiveTab: selectTab,
      resetTab,
    }),
    withHandlers({
      selectTab: props => tab => () => props.selectActiveTab(tab),
    }),
    withPropsOnChange(['noBarber'], (props) => {
      if (props.noBarber) {
        props.selectActiveTab(SERVICES_TAB);
      }
    }),
    lifecycle({
      componentDidMount() {
        if (this.props.location.state && this.props.location.state.openNewMembershipSale) {
          if (this.props.noBarber) {
            this.props.addBarber(UNASSIGNED_BARBER);
          }
          this.props.setCustomer(this.props.location.state.customer);
          this.props.setPreserveOrderCustomer(true);
          this.props.selectActiveTab(MEMBERSHIPS_TAB);
          this.props.router.replace({ pathname: this.props.location.pathname, state: null });
        }
      },
      componentWillUnmount() {
        this.props.setPreserveOrderCustomer(false);
        this.props.resetTab();
      },
    }),
    nonOptimalStates([
      { when: props => props.noBarber, render: Barbers },
    ]),
)(Sale);
